import { Component, Input } from '@angular/core';

export const WHITELISTED_LOGO_IDS = [
  1864786,
  733950,
  592872,
  731288,
  401288,
  516510,
  765299,
  743376,
  1855,
  1785,
  531016,
  756242,
  512780,
  942184,
  727735,
  21486,
  743457,
  740372,
  727394,
  741004,
  511157,
  778764,
  759517,
  217720,
  398336,
  399499,
  923726,
  990986,
  15672,
  398353,
  18086,
  398964,
  6658,
  398383,
  401375,
  1268,
  479941,
  457080,
  212652,
  806858,
  17691,
  459352,
  724,
  348384,
  759275,
  479099,
  804777,
  896685,
  591878,
  17304,
  17700,
  17510,
  398682,
  923,
  207047,
  19798,
  398671,
  727557,
  1483,
  511891,
  2764,
  1619822,
  398438,
  396077,
  7867,
  347833,
  211321,
  398602,
  13529,
  387048,
  2433,
  398539,
  2031,
  208186,
  398643,
  401244,
  19346,
  412425,
  6400,
  398541,
  422426,
  21140,
  804617,
  887312,
  431685,
  774149,
  17308,
  13834,
  484312,
  18726,
  5075,
  433794,
  208098,
  766893,
  20899,
  398848,
  3514,
  16664,
  250081080,
  446513,
  794,
  428889,
  929611,
  444114,
  422577,
  444980,
  447297,
  218396,
  414455
];

export function logoUrl(orionId: number, size: number) {
  if (WHITELISTED_LOGO_IDS.indexOf(orionId) > -1) {
    return `https://cdn.home.ipreo.com/dealer-logos/${orionId}.png`;
  } else {
    return `https://via.placeholder.com/${size}/FFFFFF/FFFFFF?Text=Blank`;
  }
}

@Component({
  selector: 'muni-shared-bank-logo',
  template:
    '<img [src]="getUrl()" alt="bank logo" [width]="size" [height]="size" data-automation-e2e-selector="bank-logo"/>',
  standalone: false,
})
export class BankLogoComponent {
  @Input()
  public orionId: number;

  @Input()
  public size = 70;

  public getUrl() {
    return logoUrl(this.orionId, this.size);
  }
}
